import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { AvatarListStyle } from './types'

@safeCustomElement('mdc-avatar-list')
export class MdcAvatarList extends LitElement {
  @property({ type: String }) variant: AvatarListStyle = 'default'

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-avatar-list {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 100%;
			padding-top: 0.0625rem;
		}

		.mdc-avatar-list--style-has-border-top {
			border-top: 1px solid var(--color-functional-gray-75);
		}
	`

  render() {
    const className = `mdc-avatar-list mdc-avatar-list--style-${this.variant}`

    return html`
			<div class=${className}>
				<slot></slot>
			</div>
		`
  }
}
